import logo from '@/assets/images/logo.svg';
import background from '@/assets/images/share.svg';
import { Stage } from 'konva/lib/Stage';
import { forwardRef } from 'react';
import { Group, Image as KImage, Stage as KStage, Layer } from 'react-konva';
import { GraphDataExtended, Node } from './PlayersCardsSummary';
import { SubmittedDrawPlayerImage } from '@/utils/submittedDrawing';
import { COMPACT_CARD_SIZE, DEFAULT_CARD_SIZE } from './PlayersCards';

/**
 * PlayersCards component displays a network of player cards with interactive features.
 */
const PlayersCardsSummaryShare = forwardRef(
  ({ graphData }: { graphData: GraphDataExtended }, ref: React.LegacyRef<Stage>) => {
    const gameContainerDimensions = {
      width: 1920,
      height: 1080
    };
    const CARD_SIZE = graphData.nodes.length > 10 ? COMPACT_CARD_SIZE : DEFAULT_CARD_SIZE;

    /**
     * Renders a single node (player card) in the graph.
     */

    const renderNode = (node: Node) => {
      const drawing = JSON.parse(node.card.drawing ?? '{}');

      return (
        <Group
          key={node.id}
          ref={(ref) => {
            if (ref && gameContainerDimensions.width > 0) {
              ref.offsetX(CARD_SIZE.width / 2); // Move the offset to the centre of the shape
              ref.offsetY(CARD_SIZE.height / 2);
            }
          }}
          x={node.x}
          y={node.y}
          rotation={node.rotation}
        >
          <SubmittedDrawPlayerImage drawing={drawing} cardSize={CARD_SIZE} />
        </Group>
      );
    };

    const backgroundImg = new Image();
    backgroundImg.src = background;

    const logoImg = new Image();
    logoImg.src = logo;

    // Using the width and height of the game of the graphData, normalize it to the new width and height
    // and create an offset to apply to the group of nodes
    const offset = {
      x: gameContainerDimensions.width / 2 - graphData.width / 2,
      y: gameContainerDimensions.height / 2 - graphData.height / 2
    };

    return (
      <div className="hidden">
        <KStage
          ref={ref}
          width={gameContainerDimensions.width}
          height={gameContainerDimensions.height}
        >
          <Layer>
            <KImage
              image={backgroundImg}
              x={gameContainerDimensions.width / 2 - gameContainerDimensions.width / 2}
              y={gameContainerDimensions.height / 2 - gameContainerDimensions.height / 2}
              width={gameContainerDimensions.width}
              height={gameContainerDimensions.height}
            />
            <Group x={offset.x} y={offset.y + 100}>
              {graphData.nodes.map(renderNode)}
            </Group>
            <KImage
              image={logoImg}
              x={gameContainerDimensions.width / 2 - 507.21 / 2}
              y={146.88 / 2}
              width={507.21}
              height={146.88}
            />
          </Layer>
        </KStage>
      </div>
    );
  }
);

PlayersCardsSummaryShare.displayName = 'PlayersCardsSummaryShare';

export default PlayersCardsSummaryShare;
